// @ts-nocheck
export function dynamicSort(property) {
    /* from https://stackoverflow.com/questions/1129216/sort-array-of-objects-by-string-property-value */
    var sortOrder = 1;
    if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        /* next line works with strings and numbers, 
         * and you may want to customize it to your needs
         */
        if (property.includes('.')) {
            let prop = property.split('.');
            var result = (a[prop[0]][prop[1]] < b[prop[0]][prop[1]]) ? -1 : (a[prop[0]][prop[1]] > b[prop[0]][prop[1]]) ? 1 : 0;
        } else {
            var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        }
        return result * sortOrder;
    }
}

export function dynamicSortMultiple() {
    /*
     * save the arguments object as it will be overwritten
     * note that arguments object is an array-like object
     * consisting of the names of the properties to sort by
     */
    var props = arguments;
    return function (obj1, obj2) {
        var i = 0, result = 0, numberOfProperties = props.length;
        /* try getting a different result from 0 (equal)
         * as long as we have extra properties to compare
         */
        while (result === 0 && i < numberOfProperties) {
            result = dynamicSort(props[i])(obj1, obj2);
            i++;
        }
        return result;
    }
}

export function findTranslation(translations, lng) {
    return translations.find((el) => el.languages_code === lng);
}

export function getTranslationField(translations, locale, fallbackLocales, field) {
    const locales = [
        locale,
        ...(Array.isArray(fallbackLocales) ? fallbackLocales : [fallbackLocales])
    ].filter(Boolean);

    for (const lang of locales) {
        const translation = findTranslation(translations, lang);

        if (translation) {
            return {
                lang,
                text: translation[field] ?? null
            };
        }
    }

    return {
        lang: null,
        text: null
    };
}

import { getLocaleFromNavigator, locale } from 'svelte-i18n';

export function resetLang() {
    let params = window.location.search;
    const urlParams = new URLSearchParams(params);

    const paramLang = urlParams.get('lang');
    const navLang = getLocaleFromNavigator()?.split('-')[0];

    if (paramLang) {
        locale.set(paramLang);
    } else if (navLang) {
        locale.set(navLang);
    }
}

import { questionErrors, guardianErrors } from '$lib/stores';

export function checkForQuestionErrors() {
    let items = document.querySelectorAll('.questions .shouldAlert');
    if (items.length > 0) {
        questionErrors.set(true);
        return items[0];
    } else {
        return false;
    }
}

export function checkForGuardianErrors() {
    let items = document.querySelectorAll('.guardian .shouldAlert');
    if (items.length > 0) {
        guardianErrors.set(true);
        return items[0];
    } else {
        return false;
    }
}

import { reading, user } from '$lib/stores';
import { get } from 'svelte/store';

export function listenForTexts() {

    const readText = (element) => {
        if (localStorage.getItem("appTTS_" + get(user)) === "true") {
            /* The conditional is only there for settings view where listeners may still exist
            although you turned off the setting. */

            /* The utterance.voice is a Safari desktop bugfix, it did not listen to utterance.lang but went with navigator lang instead. */

            let strippedElement = element.textContent;
            let utterance = new SpeechSynthesisUtterance(strippedElement);
            const voicesList = window.speechSynthesis.getVoices()
            if (element.getAttribute('lang')) {
                utterance.lang = element.getAttribute('lang');
                utterance.voice = voicesList.find((voice) => voice.lang.startsWith(element.getAttribute('lang')))
            } else {
                let htmlEl = document.getElementsByTagName('html');
                utterance.lang = htmlEl[0].getAttribute('lang');
                utterance.voice = voicesList.find((voice) => voice.lang.startsWith(htmlEl[0].getAttribute('lang')))
            }
            if (utterance.lang === 'af') {
                /* No support for Afrikaans, closest is Dutch. */
                utterance.lang = 'nl';
                utterance.voice = voicesList.find((voice) => voice.lang.startsWith('nl'))
            }
            if (utterance.lang === 'is') {
                /* No support for Icelandic, closest is Norweigan. */
                utterance.lang = 'nb';
                utterance.voice = voicesList.find((voice) => voice.lang.startsWith('nb'))
            }
            reading.set(true);
            speechSynthesis.speak(utterance);
            utterance.onend = (e) => {
                reading.set(false);
            }
        }
    };

    if (localStorage.getItem("appTTS_" + get(user)) === "true") {
        let allReadItems = document.querySelectorAll('.app-view .read');
        Object.entries(allReadItems).forEach((el) => {
            if (!el[1].classList.contains('listener')) {
                el[1].addEventListener('click', () => readText(el[1]));
                el[1].classList.add('listener');
            }
        });
    }

    return {
        destroy() {
            reading.set(false);
            speechSynthesis.cancel();
        }
    }
}

export function listenForSounds() {
    let buttonSound = new Audio('/audio/button.wav');
    let checkboxSoundOn = new Audio('/audio/checkboxPos.mp3');
    let checkboxSoundOff = new Audio('/audio/checkboxNeg.mp3');
    let switchSound = new Audio('/audio/switch.wav');

    const playSound = (sound, element) => {
        if (localStorage.getItem("appAudio_" + get(user)) === "true") {
            /* The conditional is only there for settings view where listeners may still exist
            although you turned off the setting. */

            if (sound === 'button') {
                buttonSound.play();
            } else if (sound === 'check') {
                if (element.classList.contains('checkOn')) {
                    checkboxSoundOn.play();
                } else if (element.classList.contains('checkOff')) {
                    checkboxSoundOff.play();
                }
            } else if (sound === 'switch') {
                switchSound.play();
            }
        }
    }

    if (localStorage.getItem("appAudio_" + get(user)) === "true") {
        let buttonAudio = document.querySelectorAll('.app-view .audioButton');
        let checkboxAudio = document.querySelectorAll('.app-view .audioCheckbox');
        let switchAudio = document.querySelectorAll('.app-view .audioSwitch');

        Object.entries(buttonAudio).forEach((el) => {
            if (!el[1].classList.contains('listener')) {
                el[1].addEventListener('click', () => playSound('button', false));
                el[1].classList.add('listener');
            }
        });
        Object.entries(checkboxAudio).forEach((el) => {
            if (!el[1].classList.contains('listener')) {
                el[1].addEventListener('click', () => playSound('check', el[1]));
                el[1].classList.add('listener');
            }
        });
        Object.entries(switchAudio).forEach((el) => {
            if (!el[1].classList.contains('listener')) {
                el[1].addEventListener('click', () => playSound('switch', false));
                el[1].classList.add('listener');
            }
        });
    }

}

export const asyncTimeout = (ms) => {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
};

import { tick } from 'svelte';

export async function key(...vars) {
    return vars.join(';');
}

export function customerName(array, id) {
    let customer = array.find((el) => el.id === id);
    return customer.name;
}